import { Flex, Text } from '@chakra-ui/react'
import React, { ComponentProps } from 'react'
import { ImageIcon } from '~/components/ImageIcon'
import { dimensions, light, spacing } from '~/constants/theme'

export const PageContainer = (props: ComponentProps<typeof Flex>) => {
  return (
    <Flex grow={1} bg={light.gray300}>
      {props.children}
    </Flex>
  )
}

export const TabList = (props: ComponentProps<typeof Flex>) => {
  return (
    <Flex
      h="100%"
      w={dimensions.sidebarWidth + 'px'}
      p="20px 12px"
      direction="column"
      shrink={0}
      bg={light.gray200}
    >
      {props.children}
    </Flex>
  )
}

export const SettingsHeader = (props: ComponentProps<typeof Flex>) => {
  return (
    <Flex
      h="72px"
      w="100%"
      p="10px 12px"
      direction="row"
      shrink={0}
      align="center"
      bg={light.gray200}
      borderBottom="2px solid var(--light-gray-400, #e4e4eb)"
      marginBottom={'.25rem'}
    >
      <Text fontSize="20px" color={light.dark900} fontWeight="700" mb={0}>
        {props.children}
      </Text>
    </Flex>
  )
}

export const SettingControlsWrapper = (props: ComponentProps<typeof Flex>) => {
  return (
    <Flex
      h="100%"
      minH="500px"
      maxW="800px"
      direction="column"
      flex={1}
      bg={light.gray300}
    >
      {props.children}
    </Flex>
  )
}

export const SettingsTab = (
  props: ComponentProps<typeof Flex> & {
    icon: SVGAsset
    active: boolean
    label: string
  },
) => {
  return (
    // We could probably use the <Button> component once we set up our color palette
    <Flex
      as="button"
      direction="row"
      w="100%"
      p={spacing.spacingLG}
      borderRadius={dimensions.borderRadiusSM}
      align="center"
      cursor="pointer"
      bg={props.active ? light.gray400 : light.gray200}
      _hover={{ bg: light.gray300 }}
      _active={{ bg: light.gray400 }}
      onClick={props.onClick}
    >
      <ImageIcon width="22" height="22" icon={props.icon} />
      <Text
        fontSize="14px"
        color={light.dark900}
        fontWeight={props.active ? '600' : 'normal'}
        ml={spacing.spacingMD}
        mb={0}
      >
        {props.label}
      </Text>
      {props.children}
    </Flex>
  )
}

export const Version = (props: ComponentProps<typeof Flex>) => {
  return (
    <Flex w="100%" align="center" justify="center">
      <Text fontSize="12px" color={light.dark700} fontWeight="600" mb={0}>
        {props.children}
      </Text>
    </Flex>
  )
}
export const Warning = (props: ComponentProps<typeof Flex>) => {
  return (
    <Flex
      w="100%"
      h="36px"
      align="center"
      justify="center"
      bg={light.redAlert}
      p="0 10px"
      borderRadius={dimensions.borderRadiusSM}
    >
      <Text fontSize="24px" color={light.dark600} fontWeight="600" mb={0}>
        {props.children}
      </Text>
    </Flex>
  )
}
